module.exports = __webpack_public_path__ + "static/img/partInquriyDetail-1.0940d81a.png";